import * as React from 'react'

export const ToPercent = (val?: number): string =>
  val == null
    ? '--'
    : val.toLocaleString(undefined, {
        style: 'percent',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      })

export const ToHours = (val?: number): string =>
  val == null
    ? '--'
    : val.toLocaleString(undefined, { maximumFractionDigits: 1, minimumFractionDigits: 1 })

export const DurationFormatter = (miliSeconds: number) =>
  miliSeconds === null || miliSeconds === undefined
    ? '---'
    : miliSeconds < 0
    ? 'Not in selected period'
    : convertMS(miliSeconds)

export const DateFormatter = (date?: Date, startOfPeriod?: Date) => {
  if (!date) {
    return <span className="wordwrap">Unclosed</span>
  }

  // All datetimess in the UI are assumed to be in the site timezone. However, we do not have this timezone information available.
  // In order to avoid converting between timezones we perform all datetime actions (inputting and fomatting) as though we are in UTC.
  const language = window.navigator.language
  const optionsDifferentYear: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' }
  const optionsDifferentMonth: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', timeZone: 'UTC' }
  const optionsSameMonth: Intl.DateTimeFormatOptions = { day: 'numeric', timeZone: 'UTC' }
  const isDateThisYear = startOfPeriod && startOfPeriod.getFullYear() === date.getFullYear()
  const isDateThisMonth = startOfPeriod && startOfPeriod.getMonth() === date.getMonth()
  const datePart = date.toLocaleDateString(
    language,
    isDateThisYear
      ? isDateThisMonth
        ? optionsSameMonth
        : optionsDifferentMonth
      : optionsDifferentYear
  )

  const hours = date.getUTCHours()
  const minutes = date.getUTCMinutes()
  const seconds = date.getUTCSeconds()
  const timePart = ` at ${hours}:${addLeadingZero(minutes)}:${addLeadingZero(seconds)}`
  return (
    <span className="wordwrap">
      {datePart}
      {isDateThisYear && isDateThisMonth && <sup>{GetOrdinalSuffix(date.getUTCDate())}</sup>}
      {timePart}
    </span>
  )
}

function convertMS(ms: number): string {
  var s = Math.floor(ms / 1000)
  var m = Math.floor(s / 60)
  s = s % 60
  var h = Math.floor(m / 60)
  m = m % 60
  return h + ':' + addLeadingZero(m) + ':' + addLeadingZero(s)
}

function addLeadingZero(i: number): string {
  if (i < 10) {
    return '0' + i.toString()
  } else {
    return i.toString()
  }
}

const GetOrdinalSuffix = (day: number): string => {
  if (day === 1 || day === 21 || day === 31) {
    return 'st'
  } else if (day === 2 || day === 22) {
    return 'nd'
  } else if (day === 3 || day === 23) {
    return 'rd'
  } else {
    return 'th'
  }
}
